// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__10RhG","title":"ClientInsurance_title__25EDC","itemText":"ClientInsurance_itemText__1Fr8S"};